import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import i18n from "i18next";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Slide from '@mui/material/Slide';
import FinancialData from '../FinancialData/FinancialData';
import negitiveStringDisply from '../../../utils/Utilities';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.action.hover,
    borderSpacing: "10px"
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledeRow = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.action.hover,
    borderSpacing: "10px"
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
const headColumns = [
  "financialYearEndDate",
  "sourceOfFinancialStatements",
  "dateofinterimfinancialstatement"
];
const LiquidityColumns = [
  "workingCapital",
  "daysOverheadCoveredinWorkingCapital",
  "workingCapitalPercenttoRevenue",
  "workingCapitalTurnover",
  "currentRatio",
  "quickRatio",
  "defensiveIntervalRatio",
  "netOverBillings",
  "netOverBillingPercentageRevenue",
  "daysRevenueinReceivables",
  "daysCash",
  "cashtoOverBillings",
  "cashtoEquity",
  "cashtoRevenue",
  "debtCoverageRatio",
];

const negativeHandleingField = [
  "netOverBillings",
 
];
const dollarColumns = [
  "netOverBillings",

];

const BacklogColumns = [
  "bondingCapacity",
  "backlogPercentageBondingCapacity",
  "backlogPercentageRevenue",
  "backlogGrossProfitGAExpense",
  "monthsRevenueBacklog",
];
const LeverageratiosColumns = [
  "equityRevenue",
  "interestBearingDebtEquity",
  "debtWorkingCapital",
  "totalLiabilitiesEquity",
];
const ProfitabilityratiosColumns = [
  "grossProfitPercentage",
  "gaPercentage",
  "pretaxEarningsPercentage",
  "pretaxReturnCurrentYearEquity",
  "pretaxReturnCurrentYearAssets",
  "afterTaxReturnCurrentYearEquity",
  "afterTaxReturnCurrentYearAssets",
  "ebitda",
  "asPercentageRevenue",
];

export default function FinancialAnalytics(props) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const navigate = useNavigate();

  const handleClickOpen = () => {
    // navigate("/finacialAnalytics");
    setOpen(true);
  };

  const avg = (n1, n2, n3, n4) => {
    // Remove non-numeric characters and replace "N/A" with "0.0"
    n1 = parseFloat(n1?.replace(/[^0-9\.-]+/g, "") || "0.0");
    n2 = parseFloat(n2?.replace(/[^0-9\.-]+/g, "") || "0.0");
    n3 = parseFloat(n3?.replace(/[^0-9\.-]+/g, "") || "0.0");
    n4 = parseFloat(n4?.replace(/[^0-9\.-]+/g, "") || "0.0");

    // Calculate the average
    const sum = n1 + n2 + n3 + n4;
    const average = sum / 4;

    // Round the average to the nearest whole number
    const roundedAverage = Math.round(average);

    return average?.toLocaleString("en-US");
};


  const handleClose = () => {
    setOpen(false);
  };


  const data = props;


  var d = new Date();
  return (
    <>
      <Box
        sx={{
          backgroundColor: 'white',
          display: props?.COUNT == 0 ? "none" : "block"
        }}

      >

        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          TransitionComponent={Transition}
        >

          <FinancialData Pqid={props?.pqid} handleClose1={handleClose} />
        </Dialog>
        <TableContainer hidden={!data} component={Paper}>
          <Button className='mx-3 my-3' onClick={handleClickOpen} sx={{ padding: "15px", textTransform: "capitalize" }} variant="contained">Financial Data</Button>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>&nbsp;</StyledTableCell>
                <StyledTableCell align="right" className='text-muted'>{t('financialAnalyticshead.currentytd')}</StyledTableCell>
                <StyledTableCell align="right" className='text-muted'>{t('financialAnalyticshead.previousyearytd')} </StyledTableCell>
                <StyledTableCell align="right" className='text-muted'>{t('financialAnalyticshead.2yearsPrevious')}</StyledTableCell>
                <StyledTableCell align="right" className='text-muted'>{t('financialAnalyticshead.3yearsPrevious')}&nbsp;</StyledTableCell>
                <StyledTableCell align="right" className='text-muted'>{t('financialAnalyticshead.average')}&nbsp;</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody >
              {headColumns?.map((r, index) => (
                <TableRow key={index}>
                  <StyledTableCell >{t(r)}</StyledTableCell>
                  {[...Array(4)]?.map((e, i) => <StyledTableCell align="right" key={i} hidden={!data?.[i]?.[r]}>{data?.[i]?.[r]?.replace(/-/g, '/')}</StyledTableCell>)}
                  <StyledTableCell align="right" className='text-muted'>&nbsp;</StyledTableCell>
                  {/* <StyledTableCell align="right" >{avg(data?.[0]?.[r], data?.[1]?.[r], data?.[2]?.[r], data?.[3]?.[r])}</StyledTableCell> */}
                </TableRow>
              ))}
            </TableBody>
            <TableHead>
              <TableRow>
                <StyledTableCell className='text-muted'>{t('financialAnalyticshead.liquidity')}</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {LiquidityColumns?.map((r, index) => (
                <TableRow key={index}>
                  <StyledTableCell>
                    {r === 'workingCapital' ? '' : ''}
                    {r === 'netOverBillings' ? '' : ''}
                    {t(r)}
                    
                    {r === 'workingCapitalPercenttoRevenue' ? '' : ''}
                  </StyledTableCell>
                  {[...Array(4)].map((e, i) => (
                    <StyledTableCell align="right" key={i}>
                      {r === 'workingCapital' ? '$ ' : ''}
                      {/* {r === 'netOverBillings' ? '$ ' : ''} */}
                      { negativeHandleingField.indexOf(r) === -1? data?.[i]?.[r]:negitiveStringDisply(data?.[i]?.[r],dollarColumns?.indexOf(r) !== -1)}
                      {r === 'workingCapitalPercenttoRevenue' && data?.[i]?.[r]!=="N/A"? '%' : ''} 
                      {r === 'cashtoEquity' && data?.[i]?.[r]!=="N/A"? '%' : ''}  
                     {r === "netOverBillingPercentageRevenue" ?"%":""} 
                    </StyledTableCell>
                  ))}
                  <StyledTableCell align="right">
                    {r === 'workingCapital' ? '$ ' : ''}
                    {r === 'netOverBillings' ? '$ ' : ''}
                    {avg(data?.[0]?.[r], data?.[1]?.[r], data?.[2]?.[r], data?.[3]?.[r])}
                    {r === 'netOverBillings' ? '%' : ''}
                    {r === 'workingCapitalPercenttoRevenue' ? '%' : ''}
                    {r === "netOverBillingPercentageRevenue" ?"%":""} 
                  </StyledTableCell>
                </TableRow>
              ))}

            </TableBody>
            <TableHead>
              <TableRow>
                <StyledTableCell className='text-muted'>{t('financialAnalyticshead.backlog')}</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* {BacklogColumns.map((r, index) => (
                <TableRow key={index}>
                  <StyledTableCell>{t(r)}</StyledTableCell>
                  {[...Array(4)].map((e, i) => <StyledTableCell align="right" key={i} >{data?.[i]?.[r]}</StyledTableCell>)}
                  <StyledTableCell align="right" >{avg(data?.[0]?.[r], data?.[1]?.[r], data?.[2]?.[r], data?.[3]?.[r])}</StyledTableCell>
                </TableRow>
              ))} */}
               {BacklogColumns?.map((r, index) => (
                <TableRow key={index}>
                  <StyledTableCell>
                    {r === 'bondingCapacity' ? '' : ''}
                    {t(r)}
                    {r === 'bondingCapacity' ? '' : ''}
                  </StyledTableCell>
                  {[...Array(4)].map((e, i) => (
                    <StyledTableCell align="right" key={i}>
                      {r === 'bondingCapacity' ? '$ ' : ''}

                      {data?.[i]?.[r]}
                      {r === 'backlogPercentageBondingCapacity' && data?.[i]?.[r]!=="N/A"? '%' : ''} 
                      {r === 'backlogPercentageRevenue'  && data?.[i]?.[r]!=="N/A"? '%' : ''} 
                      {r === 'backlogGrossProfitGAExpense' && data?.[i]?.[r]!=="N/A"? '%' : ''} 
                    </StyledTableCell>
                  ))}
                  <StyledTableCell align="right">
                    {r === 'bondingCapacity' ? '$ ' : ''}

                    {avg(data?.[0]?.[r], data?.[1]?.[r], data?.[2]?.[r], data?.[3]?.[r])}
                    {r === 'backlogPercentageBondingCapacity' ? '%' : ''} 
                      {r === 'backlogPercentageRevenue' ? '%' : ''} 
                      {r === 'backlogGrossProfitGAExpense' ? '%' : ''} 
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableHead>
              <TableRow>
                <StyledTableCell className='text-muted'>{t('financialAnalyticshead.leverageratios')}</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* {LeverageratiosColumns.map((r, index) => (
                <TableRow key={index}>
                  <StyledTableCell>{t(r)}</StyledTableCell>
            
                  <StyledTableCell align="right" >{avg(data?.[0]?.[r], data?.[1]?.[r], data?.[2]?.[r], data?.[3]?.[r])}</StyledTableCell>
                </TableRow>
              ))} */}
              {LeverageratiosColumns?.map((r, index) => (
                <TableRow key={index}>
                  <StyledTableCell>
                    {r === 'bondingCapacity' ? '' : ''}
                    {t(r)}
                    {r === 'bondingCapacity' ? '' : ''}
                  </StyledTableCell>
                  {[...Array(4)].map((e, i) => (
                    <StyledTableCell align="right" key={i}>
                    

                      {data?.[i]?.[r]}
                      {r === 'equityRevenue' && data?.[i]?.[r]!=="N/A"? '%' : ''} 
                      {r === 'totalLiabilitiesEquity' && data?.[i]?.[r]!=="N/A"? '%' : ''} 
                 
                    </StyledTableCell>
                  ))}
                  <StyledTableCell align="right">
                    {r === 'bondingCapacity' ? '$ ' : ''}

                    {avg(data?.[0]?.[r], data?.[1]?.[r], data?.[2]?.[r], data?.[3]?.[r])}
                    {r === 'equityRevenue' ? '%' : ''} 
                      {r === 'totalLiabilitiesEquity' ? '%' : ''} 
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableHead>
              <TableRow>
                <StyledTableCell className='text-muted'>{t('financialAnalyticshead.profitabilityratios')}</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* {ProfitabilityratiosColumns.map((r, index) => (
                <TableRow key={index}>
                  <StyledTableCell>{t(r)}</StyledTableCell>
                  {[...Array(4)].map((e, i) => <StyledTableCell align="right" key={i} >{data?.[i]?.[r]}</StyledTableCell>)}
              
                  <StyledTableCell align="right" >{avg(data?.[0]?.[r], data?.[1]?.[r], data?.[2]?.[r], data?.[3]?.[r])}</StyledTableCell>
                </TableRow>
              ))} */}
               {ProfitabilityratiosColumns?.map((r, index) => (
                <TableRow key={index}>
                  <StyledTableCell>
                    {r === 'bondingCapacity' ? '' : ''}
                    {t(r)}
                    {r === 'bondingCapacity' ? '' : ''}
                  </StyledTableCell>
                  {[...Array(4)].map((e, i) => (
                    <StyledTableCell align="right" key={i}>
                    

                      {data?.[i]?.[r]}
                      {r === 'grossProfitPercentage' && data?.[i]?.[r]!=="N/A"? '%' : ''} 
                      {r === 'gaPercentage'  && data?.[i]?.[r]!=="N/A"? '%' : ''} 
                      {r === 'pretaxEarningsPercentage' && data?.[i]?.[r]!=="N/A"? '%' : ''} 
                      {r === 'pretaxReturnCurrentYearEquity'&& data?.[i]?.[r]!=="N/A"? '%' : ''} 
                      {r === 'pretaxReturnCurrentYearAssets' && data?.[i]?.[r]!=="N/A"? '%' : ''} 
                      {r === 'asPercentageRevenue'  && data?.[i]?.[r]!=="N/A"? '%' : ''} 
                   
                 
                    </StyledTableCell>
                  ))}
                  <StyledTableCell align="right">
                    {r === 'bondingCapacity' ? '$ ' : ''}

                    {avg(data?.[0]?.[r], data?.[1]?.[r], data?.[2]?.[r], data?.[3]?.[r])}
                    {r === 'grossProfitPercentage' ? '%' : ''} 
                      {r === 'gaPercentage' ? '%' : ''} 
                      {r === 'pretaxEarningsPercentage' ? '%' : ''} 
                      {r === 'pretaxReturnCurrentYearEquity' ? '%' : ''} 
                      {r === 'pretaxReturnCurrentYearAssets' ? '%' : ''} 
                      {r === 'asPercentageRevenue' ? '%' : ''} 
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  )
}
